import { render, staticRenderFns } from "./CustomerContextOwnerProductChip.vue?vue&type=template&id=5951504a&scoped=true"
import script from "./CustomerContextOwnerProductChip.vue?vue&type=script&lang=js"
export * from "./CustomerContextOwnerProductChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5951504a",
  null
  
)

export default component.exports